<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
  <p style="color: black"> กำลังโหลดข้อมูล... </p>
</ngx-spinner>

<div class="content-wrapper" style="min-height: 307px">
  <div class="card">
    <div class="card-header bg-primary">
      <b>รายการขอเกี๊ยวปี {{year_S[0].yearDesc}}</b>
      <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="Loadlistaskformoney();"><i class="fas fa-sync"></i>
        </button>
        <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="row" [ngSwitch]="edit_st">
        <div class="col-sm-2">
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>กรุณาเลือกปี </mat-label>
            <mat-select disableRipple required [(ngModel)]="year_S" (selectionChange)="Loadlistaskformoney()">
              <mat-option [value]="" disabled>-- เลือกปี --</mat-option>
              <mat-option *ngFor="let item of year_L" [value]=[item]>{{item.yearDesc}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-auto" *ngSwitchCase="0">
          <div class="form-row align-items-center">
            <div *ngFor="let item of subtype0">
              <button type="button" [ngClass]="{'btn btn-outline-primary btn-sm' : true }" name="maintype" id="t0"
                [value]="item.id" (click)="SubTypeSelectM(item.l_id)">{{item.doc}}
              </button>
            </div>
            <button type="button" [ngClass]="{'btn btn-outline-danger btn-sm' : true }" name="maintype" id="t0"
              (click)="resetdata()">รีเซ็ตกรอง</button>
          </div>
          <div class="form-row align-items-center">
            <div *ngFor="let item of subtype1">
              <button type="button" [ngClass]="{'btn btn-outline-secondary btn-sm' : true }" name="subtype" id="t1"
                [value]="item.id" (click)="SubTypeSelectS(item.id)">{{item.doc}}
              </button>
            </div>
          </div>
        </div>

        <div class="col-sm-auto" *ngIf="list6566data.length > 0">
          <div class="button-row">

            &nbsp; &nbsp;
            <button mat-stroked-button *ngIf="edit_st == 0 && (userlevel == 7 || userlevel == 9 || userlevel == 10)"
              (click)="edit_st = 3"><mat-icon style="color: red;">first_page</mat-icon>ส่งกลับคำขอ
            </button>
            <button mat-stroked-button *ngIf="edit_st == 0 && (userlevel == 7 || userlevel == 9)"
              (click)="edit_st = 2">ส่งต่อคำขอ<mat-icon style="color: blue;">last_page</mat-icon>
            </button>
            <button mat-stroked-button *ngIf="edit_st == 0 && (userlevel == 7 || userlevel == 9 || userlevel == 10)"
              (click)="edit_st = 1"><mat-icon style="color: green;">playlist_add_check</mat-icon>การอนุมัติคำขอ
            </button>
            &nbsp; &nbsp;
            <button mat-stroked-button *ngIf="edit_st != 0" (click)="saveData()">
              <mat-icon style="color: green;"> done </mat-icon>
              <b *ngSwitchCase="1">บันทึก การอนุมัติคำขอ </b>
              <b *ngSwitchCase="2">บันทึก ส่งต่อ </b>
              <b *ngSwitchCase="3">บันทึก ส่งกลับ </b>
            </button>&nbsp;
            <button mat-stroked-button *ngIf="edit_st != 0" (click)="edit_st = 0">
              <mat-icon style="color: red;"> close </mat-icon>ยกเลิก
            </button>
          </div>
        </div>

        <div *ngSwitchCase="1" class="col-sm-auto">
          <mat-card-content>
            <mat-form-field appearance="fill">
              <mat-label>วันที่ตั้งหนี้({{data2.date_debt|adtob}})</mat-label>
              <input matInput [matDatepicker]="picker" [(ngModel)]="data2.date_debt"
                style="text-align:center; background: #fff3ad; width: auto;">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </mat-card-content>
        </div>
        <div *ngSwitchCase="1" class="col-sm-auto">

          <p>
            โอนเข้าธนาคาร [<b>{{data2.bank}}</b>]
            <mat-button-toggle-group [(ngModel)]="data2.bank" aria-label="Font Style">
              <mat-button-toggle value="LH">LH</mat-button-toggle>
              <mat-button-toggle value="KTB">KTB</mat-button-toggle>
              <mat-button-toggle value="SG">SG</mat-button-toggle>
            </mat-button-toggle-group>
          </p>
        </div>

        <div *ngSwitchCase="2" class="col-sm-auto">
          <section class="example-section">
            <label class="example-margin">ส่งต่อไปยัง:</label>
            <mat-radio-group [(ngModel)]="data2.goto">
              <mat-radio-button class="example-margin" value=0
                *ngIf="n_name[0].next">{{n_name[0].next}}</mat-radio-button>
              &nbsp;&nbsp;
              <mat-radio-button class="example-margin" value=1
                *ngIf="n_name[0].next2">{{n_name[0].next2}}</mat-radio-button>
            </mat-radio-group>
          </section>
        </div>

        <div *ngSwitchCase="3" class="col-sm-auto">
          <section class="example-section">
            <label class="example-margin">ส่งกลับไปยัง:</label>
            <mat-radio-group [(ngModel)]="data2.backto">
              <mat-radio-button class="example-margin" value=1
                *ngIf="n_name[0].back2">{{n_name[0].back2}}</mat-radio-button>
              &nbsp;&nbsp;
              <mat-radio-button class="example-margin" value=0
                *ngIf="n_name[0].back">{{n_name[0].back}}</mat-radio-button>

            </mat-radio-group>
          </section>
        </div>

        <div *ngIf="edit_st != 0" class="col-sm-auto">
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>ระบุหมายเหตุ</mat-label>
            <textarea matInput style="background: #fff3ad;" [(ngModel)]="data2.Doc"></textarea>
          </mat-form-field>
        </div>
        <div *ngSwitchCase="1" class="col-sm-auto">
          <div *ngIf="userlevel!='10'">
            <i style="text-align:center"><b>หัวหน้าแผนกสินเชื่อ ภาระหนี้รวมครั้งนี้ไม่เกิน <span
                  class="badge badge-danger">100,000</span>
                บาท</b></i>
            <br>
            <i style="text-align:center"><b>ผช.ผจก ฝ่ายสินเชื่อ ภาระหนี้รวมครั้งนี้ไม่เกิน <span
                  class="badge badge-danger">300,000</span>
                บาท</b></i>
          </div>
        </div>
      </div>

      <table class="table table-sm table-striped table-bordered" #listdoc89>
        <thead>
          <tr style="text-align:center">
            <th scope="col">เลือก </th>
            <th scope="col">เลขที่คำขอ </th>
            <th scope="col"><mat-icon>person_add</mat-icon> </th>
            <th scope="col">วันที่</th>
            <th scope="col">โควตา</th>
            <th scope="col">ชื่อ-นามสกุล</th>
            <!--<th scope="col">หัวข้อ</th>-->
            <th scope="col">เรื่องที่ขอ</th>
            <th scope="col">จำนวนเงิน</th>
            <th scope="col">สถานะ</th>
            <th scope="col">action</th>
          </tr>
        </thead>
        <tbody>
          <tr [ngSwitch]="edit_st" *ngFor="let item of list6566data" style="text-align:center"
            [ngClass]="{'table-primary':item.doc_status === '9' , 'table-secondary':item.doc_status === '8'}">
            <td>
              <section class="example-section">
                <mat-checkbox [(ngModel)]="item.modify" class="example-margin"></mat-checkbox>
              </section>
            </td>
            <td>{{item.docid}} <a mat-button color="warn" [matMenuTriggerFor]="menu" #menuTrigger
                *ngIf="item.send_back == 'Y'">(ส่งกลับ)</a></td>
            <td>{{item.supcode.trim()}}</td>
            <td>{{item.datepost_th}}</td>
            <td>{{item.fmcode}}</td>
            <td style="text-align:left">{{item.fmname}}</td>
            <!--<td>{{item.type_money_main}}</td>-->
            <td style="text-align:left">{{item.type_money_sub}}-{{item.comment1}}</td>
            <td>
              <input *ngSwitchCase="1" type="text" matInput style="text-align:right; background: #fff3ad; width: 80px;"
                [(ngModel)]="item.money_amt" />
              <div style="text-align:right" *ngIf="edit_st!=1">{{ item.money_amt | number}}</div>
            </td>
            <td style="text-align:left">{{item.docdesc}}</td>
            <td style="text-align:center">
              <div *ngSwitchCase="0" class="btn-group btn-group-sm" role="group" aria-label="Basic mixed styles example">
                <button type="button" class="btn btn-info" (click)="Datainmodel(item)"data-toggle="modal"
                data-target="#Timeline"><i
                    class="far fa-clock"></i></button>
                <button type="button" class="btn btn-warning" (click)="Datainmodel(item)"data-toggle="modal"
                data-target="#Savestatus"><i
                    class="far fa-edit"></i></button>
                <button type="button" class="btn btn-danger" (click)="Cancleid(item)"><i
                    class="far fa-window-close"></i></button>
              </div>

              <!--<div *ngSwitchCase="0"> &nbsp;
                <button type="button" class="btn btn-info btn-sm" (click)="Datainmodel(item)" data-toggle="modal"
                  data-target="#Timeline">
                  <i class="far fa-clock"></i>
                </button>&nbsp;
                <button type="button" (click)="Datainmodel(item)" class="btn btn-warning btn-sm" data-toggle="modal"
                  data-target="#Savestatus">
                  <i class="far fa-edit"></i>
                </button>&nbsp;
                <button type="button" (click)="Cancleid(item)" class="btn btn-danger btn-sm" data-toggle="modal">
                  <i class="far fa-window-close"></i>
                </button>&nbsp;
              </div>-->
            </td>
            <mat-menu #menu="matMenu">
              <!--<button mat-menu-item (click)="openDialog()">Open dialog</button>-->
              <label style="text-align:center"> {{item.text_back}} </label>
            </mat-menu>
          </tr>
        </tbody>

      </table>
    </div>
  </div>

  <!-- Modal Timeline -->
  <div class="modal fade" id="Timeline" tabindex="-1" role="dialog" aria-labelledby="TimelineLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content" *ngFor="let item of datainmodal">
        <div class="modal-header">
          <h5 class="modal-title" id="TimelineLabel">Timeline เลขที่คำขอ : {{item.docid}} </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="timeline">
            <!-- timeline time label -->
            <div class="time-label">
              <span class="bg-blue"><i class="fas fa-clock"></i> {{THtoLocalstring(item.datepost)}}</span>
            </div>
            <!-- /.timeline-label -->
            <!-- timeline item -->
            <div>
              <i class="fas fa-envelope bg-blue"></i>
              <div class="timeline-item ">
                <span class="time"></span>
                <h3 class="timeline-header bg-blue">ผู้จัดการโซน - [{{item.sup_U}}]</h3>
                <div class="timeline-body">
                  {{item.comment1}} | {{item.money_amt.toLocaleString('ar-TH')}} บาท
                </div>

              </div>
            </div>
            <!-- END timeline item -->

            <div class="time-label">
              <span class="bg-yellow"><i class="fas fa-clock"></i> {{THtoLocalstring(item.comment3date)}}</span>
            </div>
            <!-- timeline item -->
            <div>
              <i class="fas fa-comments bg-yellow"></i>
              <div class="timeline-item ">
                <span class="time"></span>
                <h3 class="timeline-header bg-yellow">พนักงานสินเชื่อ - [{{item.fn_U}}]</h3>
                <div class="timeline-body">
                  | {{item.comment3}}
                </div>
              </div>
            </div>
            <!-- END timeline item -->

            <!-- Start timeline item -->
            <div class="time-label">
              <span class="bg-green"><i class="fas fa-clock"></i> {{THtoLocalstring(item.comment4date)}}</span>
            </div>
            <!-- timeline item -->
            <div>
              <i class="fas fa-user bg-green"></i>
              <div class="timeline-item ">
                <span class="time"></span>
                <h3 class="timeline-header no-border bg-green">หัวหน้าสินเชื่อ - [{{item.head_U}}]</h3>
                <div class="timeline-body">
                  |{{item.comment4}}
                </div>
              </div>
            </div>
            <!-- END timeline item -->

            <!-- Start timeline item -->
            <div class="time-label">
              <span class="bg-info"><i class="fas fa-clock"></i> {{THtoLocalstring(item.comment5date)}}</span>
            </div>
            <!-- timeline item -->
            <div>
              <i class="fas fa-user bg-info"></i>
              <div class="timeline-item ">
                <span class="time"></span>
                <h3 class="timeline-header no-border bg-info">ผู้ช่วย ผจก.สินเชื่อ - [{{item.adj_U}}]</h3>
                <div class="timeline-body">
                  | {{item.comment5}}
                </div>
              </div>
            </div>
            <!-- END timeline item -->

            <!-- timeline time label -->
            <div class="time-label">
              <span class="bg-purple"><i class="fas fa-clock"></i> {{THtoLocalstring(item.dateapprove)}}</span>
            </div>
            <!-- /.timeline-label -->
            <div>
              <i class="fas fa-tasks bg-purple"></i>
              <div class="timeline-item ">
                <span class="time"></span>
                <h3 class="timeline-header bg-purple">ผจก.สินเชื่อ - [{{item.approve_U}}]</h3>
                <div class="timeline-body">
                  | <div *ngIf="item.doc_status =='D'">ไม่อนุมัติ </div> {{item.comment6}}
                </div>
              </div>
            </div>
            <!-- END timeline item -->
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Timeline -->

  <!-- แบบบันทึกสถานะ -->
  <div class="modal fade" id="Savestatus">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="TimelineLabel">บันทึกสถานะ {{n_name[0].now}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" *ngFor="let item of datainmodal">
          <p>เลขที่คำขอ : {{item.docid}} | {{item.fmname}} |
            {{item.comment1}} | {{item.money_amt.toLocaleString('ar-TH')}} บาท
          </p>
          <form [formGroup]="Actiocmanager" *ngFor="let item of datainmodal">
            <div class="input-group mb-3">
              <button class="btn btn-outline-secondary btn-sm" (click)="returnfinance(item,1);" data-dismiss="modal"
                *ngIf="userlevel=='9'||userlevel=='10'">
                <i class="fas fa-angle-double-left"></i> ส่งกลับ {{n_name[0].back2}} <i
                  class="fas fa-angle-double-left"></i></button>
              <button class="btn btn-outline-danger btn-sm" (click)="returnfinance(item,0);" data-dismiss="modal">
                <i class="fas fa-angle-double-left"></i> ส่งกลับ {{n_name[0].back}} <i
                  class="fas fa-angle-double-left"></i></button>
            </div>
            <div>
              <input type="text" class="form-control" placeholder="ป้อนหมายเหตุส่งกลับ(ถ้ามี)"
                formControlName="text_back">
            </div>
            <hr />

            <div *ngIf="userlevel!='10'">
              <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="ป้อนหมายเหตุ(ถ้ามี)"
                  formControlName="comment_takeask">
              </div>
              <div class="input-group mb-3">
                <button class="btn btn-outline-success btn-sm" (click)="SendtoHeaderfinance(item,0);"
                  data-dismiss="modal"> <i class="far fa-save"></i> ส่งต่อ {{n_name[0].next}} <i
                    class="fas fa-angle-double-right"></i></button>
                <button class="btn btn-outline-info btn-sm" (click)="SendtoHeaderfinance(item,1);"
                  *ngIf="userlevel=='7'" data-dismiss="modal"> <i class="far fa-save"></i> ส่งต่อ {{n_name[0].next2}} <i
                    class="fas fa-angle-double-right"></i></button>
              </div>
            </div>

            <div class="input-group mb-3">
              <table style="width:100%">
                <tr style="text-align:center">
                  <th style="width:50%">วงเงินที่ขอ</th>
                  <th style="width:50%">วงเงินที่จะอนุมัติ </th>
                </tr>
                <tr style="text-align:center">
                  <td>{{item.money_amt|number}}</td>
                  <td style="color: red;"><input type="number" class="form-control" (change)="ckcredit_approved()"
                      [(ngModel)]="credit_approved" [ngModelOptions]="{standalone: true}" id="credit_approved"></td>
                </tr>
              </table>
            </div>

            <div class="input-group mb-3">
              <span class="input-group-text">วันที่ตั้งหนี้ ({{Date_debt|adtob}})</span>
              <input type="date" class="form-control" [(ngModel)]="Date_debt" [ngModelOptions]="{standalone: true}">
            </div>
            <!-- 
            <div class="input-group mb-3">
              <input type="text" class="form-control" placeholder="ป้อนหมายเหตุ(ถ้ามี)" formControlName="comment_save">
              <button class="btn btn-outline-info btn-sm" (click)="false"><i class="fas fa-share-square"></i> บันทึกส่งต่อที่ปรีกษาทางการเงิน</button>
            </div>
          -->
            <div class="input-group mb-3">
              <span class="input-group-text">โอนเข้าธนาคาร [{{chkAccept[2]}}]</span>
              <div class="col-6 text-right">
                <ul class="nav nav-pills nav-fill mb-3" id="vert-tabs-tab" role="tablist" aria-orientation="horizontal">
                  <li class="nav-item " role="presentation">
                    <a class="nav-item nav-link" id="tabs-tab1" (click)="chkAccept[2]='LH';" data-toggle="pill">
                      LH</a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a class="nav-item nav-link" id="tabs-tab2" (click)="chkAccept[2]='KTB';" data-toggle="pill">
                      KTB</a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a class="nav-item nav-link" id="tabs-tab3" (click)="chkAccept[2]='SG';" data-toggle="pill">
                      SG</a>
                  </li>
                </ul>
              </div>
            </div>
            <!--<div class="input-group mb-3">
              <span class="input-group-text">วันที่โอนเงิน ({{chkAccept[3]|adtob}})</span>
              <input formControlName="date" [(ngModel)]="chkAccept[3]" id="datetransfer" type="date"
                class="form-control">
            </div>-->

            <div class="input-group mb-3">
              <input type="text" class="form-control" placeholder="ป้อนหมายเหตุ(ถ้ามี)"
                formControlName="comment_accept">
              <button class="btn btn-outline-success btn-sm" (click)="AcceptFinance(item.firebaseid);"
                data-dismiss="modal" [disabled]="chkAccept[0] != 1"><i class="far fa-check-circle"></i>
                อนุมัติเกี๊ยว</button>
              <button class="btn btn-outline-danger btn-sm" (click)="disapprovalFinance(item.firebaseid);"
                data-dismiss="modal">
                <i class="far fa-times-circle"></i> ไม่อนุมัติเกี๊ยว</button>
            </div>
            <div *ngIf="userlevel!='10'">
              <i style="text-align:center"><b>หัวหน้าแผนกสินเชื่อ ภาระหนี้รวมครั้งนี้ไม่เกิน <span
                    class="badge badge-danger">100,000</span>
                  บาท</b></i>
              <i style="text-align:center"><b>ผช.ผจก ฝ่ายสินเชื่อ ภาระหนี้รวมครั้งนี้ไม่เกิน <span
                    class="badge badge-danger">300,000</span>
                  บาท</b></i>
            </div>

          </form>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- แบบบันทึกสถานะ -->
<app-footer></app-footer>